
seedWebApp.controller('SelectSkuModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'HelpdeskService', 'info',
    function SelectSkuModalController($scope, $uibModalInstance, TranslationService, HelpdeskService, info) {

        $scope.translation = TranslationService.getActiveTranslation();
        console.log('SelectSkuModal');
        console.log(info);

        $scope.info = info;
        $scope.issue = info.Issue;

        $scope.loadSkus = function (orderID) {
            //var toastID = ToastService.createToast('Updating state', '', 4000, 'wait');
            HelpdeskService.getOrderSkus(orderID)
                .then(
                    function (response) {
                        //ToastService.updateToast(toastID, 'Updated', '', 2000, 'success');
                        $scope.skus = response.data;
                        $scope.loadSelected($scope.skus, $scope.issue.Details);
                    },
                    function (err) {
                        console.log('ERROR', err);
                        //ToastService.updateToast(toastID, 'ERROR', '', 2000, 'error');
                    }
                );
        }

        $scope.findSku = function (list, skuID) {
            return list.find(function (sku) {
                return sku.SkuID == skuID;
            });
        };

        $scope.loadSelected = function (skus, details) {
            skus.forEach(
                function (sku) {
                    var find = $scope.findSku(details, sku.SkuID);
                    if (find) {
                        sku.selected = true;
                    }
                }
            );
        };

        $scope.loadSkus($scope.issue.OrderID);

        $scope.getSelected = function () {
            var sel = $scope.skus.filter(function (sku) {
                return sku.selected;
            });
            return sel;
        };

        $scope.toggleAll = function () {
            $scope.skus.forEach(
                function (sku) {
                    sku.selected = !sku.selected;
                }
            );
        };

        $scope.ok = function () {
            //var selected = $scope.getSelected();
            var selected = $scope.skus;
            $uibModalInstance.close(selected);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }]
);